null


// WEBPACK FOOTER //
// ../../src/app/components/colorpicker/colorpicker.ts